var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon16PxUserCheckOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.30659 6.73074C7.47477 6.73074 8.42177 5.78365 8.42177 4.61537C8.42177 3.44708 7.47477 2.5 6.30659 2.5C5.13841 2.5 4.19141 3.44708 4.19141 4.61537C4.19141 5.78365 5.13841 6.73074 6.30659 6.73074Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30733 12.6539H2.5V12.1952C2.50674 11.5503 2.67681 10.9175 2.99434 10.3562C3.31187 9.79479 3.76649 9.32305 4.31573 8.98503C4.86499 8.64699 5.49095 8.45371 6.13514 8.4232C6.19257 8.42049 6.24998 8.41906 6.30733 8.41895C6.36468 8.41906 6.4221 8.42049 6.47953 8.4232C7.12373 8.45371 7.74968 8.64699 8.29894 8.98503C8.61478 9.1794 8.89932 9.41799 9.1445 9.69242",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5003 9.26929L10.116 13.5L8.42383 12.2308",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon16PxUserCheckOutline);
export default __webpack_public_path__ + "static/media/icon_16px_user-check_outline.f75f81a0ec47e26c0418bb4646442732.svg";
export { ForwardRef as ReactComponent };